import { FunctionComponent, useContext } from 'react';
import classnames from 'classnames';
import { AddPetContext } from 'Src/components/AddPet/AddPet';
import * as s from './FirstStepPet.css';
import * as T from './FirstStepPet.types';
const FirstStepPet: FunctionComponent<T.ItemProps> = ({ title, active, setActive, value, children, }) => {
    const addPetContext = useContext(AddPetContext);
    const { viewType } = addPetContext || {};
    const petClasses = classnames(s.root, {
        [s.active]: active === value,
        [s.petsshop]: viewType === 'petsshop',
        [s.petYear2022]: viewType === 'year2022',
    });
    const handleClick = () => {
        setActive(value);
    };
    return (<div onClick={handleClick} className={petClasses}>
      {children}
      <div>{title}</div>
    </div>);
};
export default FirstStepPet;
